export const VALID_REPLAY_EXTENSIONS = ['.packets.txt', '.worldstate.txt']
